import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import * as yup from 'yup';

export interface ISolicitationFilter {
	pageIndex: number;
	type?: string;
	category?: string;
	location?: string;
	status?: string;
}

const pageIndexSchema = yup.number().required().min(0);

const typeSchema = yup.string();
const categorySchema = yup.string();
const locationSchema = yup.string();
const statusSchema = yup.string();

export function useSolicitationsFilter() {
	const router = useRouter();
	const pathname = usePathname();
	const searchParams = useSearchParams();

	const params = {
		pageIndex: searchParams.get('pageIndex'),
		type: searchParams.get('type'),
		category: searchParams.get('category'),
		location: searchParams.get('location'),
		status: searchParams.get('status'),
	};

	const { pageIndex, type, category, location, status } = params;

	const state: ISolicitationFilter = {
		pageIndex: pageIndexSchema.isValidSync(pageIndex) ? +pageIndex : 0,
		type: typeSchema.isValidSync(type) ? type : undefined,
		category: categorySchema.isValidSync(category) ? category : undefined,
		location: locationSchema.isValidSync(location) ? location : undefined,
		status: statusSchema.isValidSync(status) ? status : undefined,
	};

	const submit = (newState: Partial<ISolicitationFilter>) =>
		router.push(getSubmitHref(newState), { scroll: false });

	const getSubmitHref = (newState: Partial<ISolicitationFilter>) => {
		const newParams = new URLSearchParams(searchParams);

		Object.entries({ ...state, ...newState }).forEach(([key, value]) => {
			if (value) {
				newParams.set(key, String(value));
			} else {
				newParams.delete(key);
			}
		});

		return `${pathname}?${newParams.toString()}`;
	};

	return {
		state,
		params,
		submit,
		getSubmitHref,
	};
}
